import LoadingSpinner from '@ui/components/LoadingSpinner';
import { lazy, Suspense } from 'react';
import styled from 'styled-components';
import useVersionChecker from '@ui/hooks/useVersionChecker';
import { versionKey } from '@apply/constants';

const GlobalProviders = lazy(() => import('@apply/providers/GlobalProviders'));
export default function App() {
    useVersionChecker(versionKey, '/');

    return (
        <Suspense
            fallback={
                <CenteredSpiner>
                    <LoadingSpinner />
                </CenteredSpiner>
            }
        >
            <GlobalProviders />
        </Suspense>
    );
}

const CenteredSpiner = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
`;
